import { Permissions } from "models/Permissions";
import { createContext } from "react";

export interface PermissionsError {
  code?: number;
  message?: string;
}

export interface PermissionsContextProps {
  permissions?: Permissions;
  setPermissions(permissions: Permissions): void;
  handleHttpError(err?: unknown): void;
  setErrorCode(errorCode: number): void;
}

export const PermissionsContext = createContext({} as PermissionsContextProps);
